import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import Notifications from "@kyvg/vue3-notification";

loadFonts();
const app = createApp(App);
app.use(store);
app.use(router);
app.use(vuetify);
app.use(Notifications);

app.mount("#app");
